const RENTER_PROFILE_PROMPT_SHOWN_KEY = 'hp_renter_profile_popup_shown';

export function hasSeenRenterProfilePrompt() {
  if (typeof window === 'undefined') return true;

  try {
    return window.localStorage.getItem(RENTER_PROFILE_PROMPT_SHOWN_KEY) === 'true';
  } catch {
    return true;
  }
}

export function markRenterProfilePromptShown() {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(RENTER_PROFILE_PROMPT_SHOWN_KEY, 'true');
  } catch {
    // Local storage is a best-effort UX hint. Submission should never fail on it.
  }
}
